import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function updateUserPlacesData(places) {
  try {
    loginfo();
    return await apiClient.post('/addFusionPlaces', { places });
  } catch (error) {
    console.error('addFusionPlaces failed.', error);
  }
}

export async function getUserPlacesData() {
  try {
    const res = await tryCache('getUserPlacesData', () => apiClient.get('/getFusionPlaces/'));

    return res;
  } catch (error) {
    console.error('getFusionPlaces failed.', error);
  }
}
